import { cn } from "@comandero/shared";
import { AppSidebar } from "@/components/app-sidebar";
import { useBackDismiss } from "@/lib/use-back-dismiss";

interface AppLayoutSidebarProps {
  isOpen: () => boolean;
  setOpen: (open: boolean) => void;
}

export function AppLayoutSidebar(props: AppLayoutSidebarProps) {
  // Browser "back" cierra el drawer móvil en vez de navegar (patrón PWA).
  useBackDismiss(
    () => props.isOpen(),
    () => props.setOpen(false),
  );

  return (
    <>
      {/* ── Mobile Sidebar Drawer ───────────────────────────────── */}
      <div
        class={cn(
          "fixed inset-0 z-[100] lg:hidden overflow-hidden",
          props.isOpen() ? "pointer-events-auto" : "pointer-events-none",
        )}
      >
        {/* Backdrop */}
        <button
          type="button"
          onClick={() => {
            props.setOpen(false);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              props.setOpen(false);
            }
          }}
          class={cn(
            "absolute inset-0 bg-black/40 backdrop-blur-[2px] border-none p-0 w-full h-full cursor-default transition-opacity duration-300 ease-swift",
            props.isOpen() ? "opacity-100" : "opacity-0",
          )}
          // eslint-disable-next-line lingui/no-unlocalized-strings -- i18n: aria-label deuda
          aria-label="Close sidebar"
        />
        {/* Drawer */}
        <aside
          class={cn(
            "absolute left-0 top-0 bottom-0 flex w-[280px] flex-col border-r border-border/40 bg-card/85 backdrop-blur-md shadow-2xl transition-transform duration-300 ease-swift will-change-transform",
            "pl-[var(--safe-area-inset-left)] pb-[var(--safe-area-inset-bottom)]",
          )}
          style={{
            transform: props.isOpen() ? "translate3d(0, 0, 0)" : "translate3d(-100%, 0, 0)",
          }}
        >
          <AppSidebar
            onCloseSidebar={() => {
              props.setOpen(false);
            }}
          />
        </aside>
      </div>

      {/* ── Desktop Sidebar ───────────────────────────────────── */}
      <aside class="hidden lg:flex w-64 shrink-0 flex-col border-r border-border/40 bg-card/10 backdrop-blur-md">
        <AppSidebar />
      </aside>
    </>
  );
}
